import { getPropsFromNode, nodeIs } from '../utils'
import { ArticleImg } from '../../components/molecule/ArticleContent/entry'
import { getTopCtx, h } from '../parser/utils'

import { getAlignmentProps } from './_utils'
import { processHref } from './links'

const EAGER_IMAGE_THRESHOLD = 6

export const NAME = 'img'

export const COMPONENTS = {
  ArticleImg,
}

export function matches(node) {
  return nodeIs(node, 'img')
}

export async function transform (node, next, ctx) {
  return h(
    ArticleImg,
    parseImgProps(node, ctx),
  )
}

// FIXME: keep query parameters in place (if any)
const WP_CROP_REGEX = /(-\d+x\d+)(\.\w{3,4})$/

export function parseImgProps(node, ctx, filter = []) {
  if (!node) {
    return
  }

  const hasSrc = node.attributes['src']?.value
  const src = processHref(hasSrc || '').replace(WP_CROP_REGEX, '$2')

  const hasSrcset = node.attributes['srcset']?.value
  const srcset = (hasSrcset || '')
    .split(',')
    .map(part => processHref(part.trim()))
    .join(', ')

  const pictureProps = getPropsFromNode(
    node,
    filter.concat(['src', 'srcset', 'loading']),
  )

  const topCtx = getTopCtx(ctx)

  return {
    ...pictureProps,
    ...(hasSrc ? { src } : null),
    ...(hasSrcset ? { srcset } : null),
    ...getAlignmentProps(node),
    ...(topCtx.location <= EAGER_IMAGE_THRESHOLD ? { lazy: false }: null),
  }
}

